// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerButton_loader__Fj9uZ","relative":"SpinnerButton_relative__G1eVe","hideText":"SpinnerButton_hideText__hBtjI"};